import { formatDate, formatPhone, SelectItemProps } from '@ui/src';
import {
  CustomerProps,
  OrganizationType,
  CustomerStatus,
} from '../../../common/types';

import cn from '../styles.module.css';

const formatIndividualCustomersList = (
  list: CustomerProps[],
  countries?: SelectItemProps[],
): CustomerProps[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    let status;

    if (result.status === CustomerStatus.ACTIVE) {
      status = 'Active';
    } else if (result.status === CustomerStatus.CLOSED) {
      status = 'Closed';
    } else if (result.status === CustomerStatus.SUSPENDED) {
      status = 'Suspended';
    } else {
      status = 'Disabled';
    }

    const render: Record<string, React.JSX.Element> = {
      type: (
        <div>
          {result.type === OrganizationType.INDIVIDUAL
            ? 'Individual'
            : 'Company Official'}
        </div>
      ),
      ids: <div className={cn.organizationIdWrapper}>{result?.ids}</div>,
      dob: <div>{result?.dob ? formatDate(result?.dob) : '-'}</div>,
      countryId: (
        <div>
          {
            countries?.find((country) => country.value === result.countryId)
              ?.name
          }
        </div>
      ),
      status: (
        <div
          className={`${
            result.status === CustomerStatus.ACTIVE ? cn.activeStatus : ''
          } ${result.status === CustomerStatus.CLOSED ? cn.closedStatus : ''}`}
        >
          {status}
        </div>
      ),
      phone: <div>{formatPhone(result?.user?.phone)}</div>,
      email: (
        <div>
          {result?.user?.profile?.additionalEmail || result?.user?.email}
        </div>
      ),
    };

    result.render = render;

    return result;
  });

  return nextList;
};

export default formatIndividualCustomersList;
